import React, { useEffect, useState, useRef } from "react";
import heart from "../../images/user-orange.svg";
import { Controller, useForm } from "react-hook-form";
import { EMAILREGEX, PHONE_TENDIGITS_REGEX, PHONE_PLACEHOLDER, ALPHANUMERICWITHSPACEREGEX, SPACE_NOT_ALLOWD, NUMBER_FORMAT_REGEX, EMAILUSERNAMEREGEX, PASSWORDREGEX, PASSWORD_ERROR, NUMBERREGEX, USER_ROLES, DEFAULT_DOMAIN, PREFERED_LANGUAGE_KEYS } from "../../App.config";
import * as utilities from "../../utilities/utils";
import backArrow from "../../images/back-arrow.svg";
import history from "../../utilities/history";
import { trim } from "lodash";
import swal from "sweetalert";
import { useLocation } from 'react-router-dom';
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";
import CustomSelect from "../../containers/Common/CustomSelect";
// import Select from 'react-select'


const AddUserForm = (props) => {
    const { control, register, handleSubmit, watch, formState: { errors }, reset, setValue, getValues } = useForm();
    const [isAdminRole, setIsAdminRole] = useState(false);
    const [isBrokerRole, setIsBrokerRole] = useState(false);
    const [isRegion, setIsRegion] = useState(false);
    const [isLevel, setIslevel] = useState(false);
    const [selectedRole, setSelectedRole] = useState(0);
    const [isFullHR, setIsFullHR] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyList, setSelectedCompanyList] = useState(undefined);
    const [defaultSelectedCompanyList, setDefaultSelectedCompanyList] = useState(undefined);

    let location = useLocation();

    // useEffect(() => {
    //     console.log(getValues("selectedCompany"));
    // }, [getValues("selectedCompany")])

    // useEffect(() => {
    //     if (defaultSelectedCompanyList && defaultSelectedCompanyList.length > 0) {
    //     }
    // }, [defaultSelectedCompanyList])

    //to set default value in useForm
    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.authUser && Object.keys(props.userAuthReducer.authUser).length !== 0 && isBrokerRole) {
            let setSelectedCompanysDefaultValue = [];
            props.userAuthReducer && props.userAuthReducer.authUser && Array.isArray(props.userAuthReducer.authUser.lstAssignedCompanies) && props.userAuthReducer.authUser.lstAssignedCompanies.map((selectedCompanyId) => {
                Array.isArray(companyList) && companyList.map((company) => {
                    if (company.value == selectedCompanyId)
                        setSelectedCompanysDefaultValue.push(company);
                })
            })
            if (setSelectedCompanysDefaultValue.length > 0) {
                setValue('selectedCompanys', setSelectedCompanysDefaultValue, { shouldDirty: true });
                setDefaultSelectedCompanyList(setSelectedCompanysDefaultValue);
                setSelectedCompanyList(setSelectedCompanysDefaultValue);
            }
        }
    }, [props.userAuthReducer && props.userAuthReducer.authUser]);

    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.companyList) {
            let companys = [];
            props.userAuthReducer.companyList.map((company) => {
                let companyObj = {
                    value: company.companyId.toString(), label: company.companyName
                }
                companys.push(companyObj);
            })
            setCompanyList(companys);
        }
    }, [props.userAuthReducer && props.userAuthReducer.companyList])
    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.authUser && props.userAuthReducer.authUser.userRoleId == USER_ROLES.ADMIN) {
            setIsAdminRole(true);
            setSelectedRole(props.userAuthReducer.authUser.userRoleId);
        }
    }, [props.userAuthReducer && props.userAuthReducer.authUser]);

    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.authUser && props.userAuthReducer.authUser.userRoleId == USER_ROLES.FULL_HR) {
            setIsFullHR(true);
            setSelectedRole(props.userAuthReducer.authUser.userRoleId);
        }
    }, [props.userAuthReducer && props.userAuthReducer.authUser]);

    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.authUser && props.userAuthReducer.authUser.userRoleId != USER_ROLES.ADMIN) {
            props.userAuthReducer.authUser.userRoleId && setSelectedRole(props.userAuthReducer.authUser.userRoleId);
        }
    }, [props.userAuthReducer && props.userAuthReducer.authUser]);

    useEffect(() => {
        if (props.userAuthReducer && props.userAuthReducer.authUser && props.userAuthReducer.authUser.regionId) {
            props.getDepartmentByRegionId(props.userAuthReducer.authUser.regionId);
            setIsRegion(true);
        }
    }, [props.userAuthReducer && props.userAuthReducer.authUser]);

    useEffect(() => {
        return function cleanup() {
            setIsAdminRole(false);
            setIsBrokerRole(false);
            setIsRegion(false);
            props.resetAuthUser();
        };
    }, []);

    // const formState = useFormState();
    useEffect(() => {
        // props.getDepartmentByCompanyId();
        props.userAuthReducer && props.userAuthReducer.selectedCompany && props.getRegionByCompanyId();
        props.userAuthReducer && props.userAuthReducer.selectedCompany && props.getAllDomainList();
    }, []);

    useEffect(() => {
        if (location && location.state && location.state.authUserId) {
            props.setIsPasswordFiedShown(false);
            props.getAuthUserById(location.state.authUserId)
        }
    }, [location && location.state])

    const normalizeInput = (value, previousValue) => {
        if (!value) return value;
        //remove any charater without alphnumeric
        const currentValue = value.replace(/[^\d]/g, "");
        const cvLength = currentValue.length;

        if (!previousValue || value.length) {
            if (cvLength < 4) {
                return currentValue;
            } else if (cvLength < 7) {
                return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
            } else {
                return `(${currentValue.slice(0, 3)})-${currentValue.slice(
                    3,
                    6
                )}-${currentValue.slice(6, 10)}`;
            }
        }
    };

    const handlePhoneNumberForDirectData = (phoneNumber) => {
        let updatedvalue = normalizeInput(phoneNumber);
        if (phoneNumber)
            setValue('contact', updatedvalue);
    }

    const handlePhoneNumber = (event) => {
        let updatedvalue = normalizeInput(event.target.value);
        setValue('contact', updatedvalue);
    };

    const onChange = (event) => {
        if (event.target.name == "userRoleId") {
            if (event.target.value == USER_ROLES.ADMIN)
                setIsAdminRole(true);

            else
                setIsAdminRole(false);

            if (event.target.value == USER_ROLES.FULL_HR)
                setIsFullHR(true);
            else
                setIsFullHR(false);
        }
        setSelectedRole(event.target.value)
    }

    const setCompanyName = () => {
        if (props.userAuthReducer && props.userAuthReducer.selectedCompany && props.userAuthReducer.companyList)
            Array.isArray(props.userAuthReducer.companyList) && props.userAuthReducer.companyList.map((company) => {
                if (company.companyId == props.userAuthReducer.selectedCompany) {
                    setValue('companyName', company.companyName, { shouldDirty: true });
                }
            })
        else {
            if (location && location.state && location.state.isAdmin) {
                // if(location.state.authUserId){
                //     props.getAuthUserById(location.state.authUserId);
                // }
                setValue('userRoleId', USER_ROLES.ADMIN, { shouldDirty: true });
                setIsAdminRole(true);
            }
            else if (location && location.state && location.state.isBroker) {
                setValue('userRoleId', USER_ROLES.BROKER, { shouldDirty: true });
                setIsBrokerRole(true);
            }
            // else if(props.quary && props.quary.get("isAdmin")){
            //     // if(!props.formData)
            //     setValue('userRoleId', 1, { shouldDirty: true });
            //     setIsAdminRole(true);
            // }
            else {
                history.push("/user-list");
                // setValue('userRoleId', 1, { shouldDirty: true });
                // setIsAdminRole(true);            
            }
        }
        // history.push("/user-list");
    }

    useEffect(() => {
        reset();
        setValue('selectedCompanys', defaultSelectedCompanyList, { shouldDirty: true });
        setCompanyName();
    }, [props.formData])

    useEffect(() => {
        if (isAdminRole || isBrokerRole)
            setValue('domain', DEFAULT_DOMAIN, { shouldDirty: true });
        else
            setValue('domain', "", { shouldDirty: true });

    }, [isAdminRole, isBrokerRole])

    const password = useRef({});
    password.current = watch("password", "");

    const handleRegionChange = (e) => {
        if (e.target.value) {
            props.getDepartmentByRegionId(e.target.value);
            setIsRegion(true);
        }
        else {
            setIsRegion(false);
        }
    }

    const handleLevelChange = (e) => {
        if (e.target.value) {
            props.getLevelItem(e.target.value);
            setIslevel(true);
            setValue("levelItem", null);
        }
        else {
            setIslevel(false);
        }
    }
    const onDrpInputchange = () => {

    }

    const openRoleInfoSwal = () => {
        let roleInfo = ""
        let roleStr = props.userAuthReducer.userRoles.find(x => x.authUserRoleId == Number(selectedRole)).name;

        switch (Number(selectedRole)) {
            case USER_ROLES.ADMIN:
                roleInfo = props.context.t("Dashboard.Access.Admin.Text");
                roleStr = props.context.t("Dashboard.Access.Admin");
                break;
            case USER_ROLES.FULL_HR:
                roleInfo = props.context.t("Dashboard.Access.FullHR.Text");
                roleStr = props.context.t("Dashboard.Access.FullHR");
                break;
            case USER_ROLES.LIMITED_CAL_HR:
                roleInfo = props.context.t("Dashboard.Access.LTDCallHR.Text");
                roleStr = props.context.t("Dashboard.Access.LTDCallHR");
                break;
            case USER_ROLES.LIMITED_CAL_MGR:
                roleInfo = props.context.t("Dashboard.Access.Manager.Text");
                roleStr = props.context.t("Dashboard.Access.Manager");
                break;
            case USER_ROLES.BROKER:
                // roleInfo = props.context.t("Dashboard.Access.Manager.Text");
                roleStr = props.context.t("Dashboard.Access.Broker");
                break;
        }
        swal(roleInfo, { title: roleStr, closeOnEsc: true });
    }

    return (
        <>
            <div className="Dashboard-Content">
                <DisplayEmployeeName context={props.context} />
                <form onSubmit={handleSubmit(props.handleSubmit)}>
                    <div className="Inner-cell">
                        <div className="Panel-cell">
                            {props.isPasswordFiedShown && <div className="Panel-header">
                                <img
                                    tabIndex="-1"
                                    className="btn btn-back"
                                    onClick={() => history.push("/user-list")}
                                    src={backArrow}
                                    alt="back-arrow"
                                />
                                <div className="p-img">
                                    <img src={heart} alt="" />
                                </div>
                                <h2>

                                    <span>
                                        Add User
                                    </span>
                                </h2>
                            </div>}
                            {!props.isPasswordFiedShown && <div className="Panel-header">
                                <img
                                    tabIndex="-1"
                                    className="btn btn-back"
                                    onClick={() => history.push("/user-list")}
                                    src={backArrow}
                                    alt="back-arrow"
                                />
                                <div className="p-img">
                                    <img src={heart} alt="" />
                                </div>
                                <h2>
                                    <span>
                                        Update User
                                    </span>
                                </h2>
                            </div>}


                            <div className="Panel-search">
                                <div className="form-row">
                                    {(location && location.state && location.state.isAdmin || location && location.state && location.state.isBroker) ?
                                        <div className="form-group col">
                                            <div className="example">
                                                <label>User Role Id
                                                    <span size="5" className="error-star">
                                                        *
                                                    </span>
                                                </label>
                                                <select className="form-control form-control-lg"
                                                    {...register("userRoleId", { required: true, value: props.formData.userRoleId, onChange: onChange })}
                                                >
                                                    {/* <option value="">-:Select Option:-</option> */}
                                                    {props.userAuthReducer && props.userAuthReducer.userRoles.map((roles, i) => {
                                                        if (location && location.state && location.state.isAdmin && roles.authUserRoleId == USER_ROLES.ADMIN) {
                                                            return (
                                                                <option
                                                                    selected={location && location.state && location.state.isAdmin && roles.authUserRoleId == USER_ROLES.ADMIN ? "selected" : ""}
                                                                    // disabled={roles.authUserRoleId != 1 ? "disabled" : ""}
                                                                    value={roles.authUserRoleId}>
                                                                    {roles.name}
                                                                </option>
                                                            )
                                                        }
                                                        else if (location && location.state && location.state.isBroker && roles.authUserRoleId == USER_ROLES.BROKER) {
                                                            return (
                                                                <option
                                                                    selected={location && location.state && location.state.isBroker && roles.authUserRoleId == USER_ROLES.BROKER ? "selected" : ""}
                                                                    // disabled={roles.authUserRoleId != 1 ? "disabled" : ""}
                                                                    value={roles.authUserRoleId}>
                                                                    {roles.name}
                                                                </option>
                                                            )
                                                        }
                                                    })
                                                    }
                                                </select>
                                                <small className="text-danger">{errors.userRoleId?.type === 'required' && "User role id required"}</small>
                                            </div>
                                        </div>
                                        :
                                        <div className="form-group col">
                                            <div className="example">
                                                <label>User Role Id
                                                    <span size="5" className="error-star">
                                                        *
                                                    </span>
                                                </label>
                                                <select className="form-control form-control-lg"
                                                    {...register("userRoleId", { required: true, value: props.formData.userRoleId, onChange: onChange })}
                                                >
                                                    <option value="">-:Select Option:-</option>
                                                    {props.userAuthReducer && props.userAuthReducer.userRoles.map((roles) => {
                                                        if (((props.userAuthReducer.companyServices?.hasDemographicFileFeature) || (roles.authUserRoleId != USER_ROLES.LIMITED_CAL_MGR)) && roles.authUserRoleId != USER_ROLES.ADMIN && roles.authUserRoleId != USER_ROLES.BROKER) {
                                                            return (
                                                                <option
                                                                    selected={props.formData && (props.formData.userRoleId == roles.authUserRoleId) && "selected"}
                                                                    value={roles.authUserRoleId}>
                                                                    {roles.name}
                                                                </option>
                                                            )
                                                        }
                                                    })
                                                    }
                                                </select>
                                                <small className="text-danger">{errors.userRoleId?.type === 'required' && "User role id required"}</small>
                                            </div>
                                        </div>}

                                    <div hidden={!selectedRole} className="form-group col-auto pt-2">
                                        <button type="button" onClick={openRoleInfoSwal} className="btn btn-info mt-4">?</button>
                                    </div>
                                    {isBrokerRole == false && isAdminRole == false && selectedRole != USER_ROLES.ADMIN && selectedRole != 0 && <div className="form-group col-md-6">
                                        <label>Company Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            disabled={true}
                                            {...register("companyName")}
                                        />
                                    </div>}

                                </div>
                                {isBrokerRole && <div className="form-row">
                                    <div className="form-group col-md-12">
                                        <label>Select Companys</label>
                                        <span size="5" className="error-star">
                                            *
                                        </span>
                                        <Controller
                                            control={control}
                                            name="selectedCompanys"
                                            defaultValue={defaultSelectedCompanyList}
                                            {...register("selectedCompanys", { required: true })}
                                            render={({ field, onChange, value, name, ref }) => (
                                                <CustomSelect
                                                    name="selectedCompanys"
                                                    className="basic-multi-select search-emp-select"
                                                    values={getValues('selectedCompanys')}
                                                    // defaultValue={defaultSelectedCompanyList}
                                                    handleChange={(selectItems, event) => {
                                                        if (event.action != "remove-value" && event.action != "clear") {
                                                            let selectedOptions = selectedCompanyList ? selectedCompanyList : [];
                                                            selectedOptions.push(event.option);
                                                            setSelectedCompanyList(selectedOptions);
                                                            setValue('selectedCompanys', selectedOptions);
                                                            // setValue('selectedCompanys', selectedOptions);
                                                        }
                                                        else {
                                                            let selectedOptions = [];
                                                            if (event && event.removedValue && !Array.isArray(event.removedValue)) {
                                                                selectedCompanyList && Array.isArray(selectedCompanyList) && selectedCompanyList.map((selectedValue) => {
                                                                    if (selectedValue.value != event.removedValue.value)
                                                                        selectedOptions.push(selectedValue);
                                                                })
                                                            }
                                                            setSelectedCompanyList(selectedOptions);
                                                            setValue('selectedCompanys', selectedOptions);
                                                            // setValue('selectedCompanys', selectedOptions);
                                                        }
                                                    }}
                                                    onInputChange={(value) => { }}
                                                    options={companyList}
                                                    isMulti={true}
                                                />
                                            )}
                                        />
                                        <small className="text-danger">{errors.selectedCompanys?.type === 'required' && "Please select companys"}</small>
                                    </div>

                                </div>}

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>First Name
                                            <span size="5" className="error-star">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter first name"
                                            defaultValue={props.formData ? trim(props.formData.firstName) : null}
                                            {...register("firstName", { required: true, pattern: SPACE_NOT_ALLOWD })}
                                        />
                                        <small className="text-danger">{errors.firstName?.type === 'required' && "First name is required"}</small>
                                        <small className="text-danger">{errors.firstName?.type === 'pattern' && "Space not allowed"}</small>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Last Name
                                            <span size="5" className="error-star">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            readOnly={props.preScreeningDetails && props.preScreeningDetails.lastName ? true : false}
                                            className="form-control"
                                            placeholder="Enter last name"
                                            {...register("lastName", { required: true, pattern: SPACE_NOT_ALLOWD })}
                                            defaultValue={props.formData ? props.formData.lastName : null}
                                        />
                                        <small className="text-danger">{errors.lastName?.type === 'required' && "Last name is required"}</small>
                                        <small className="text-danger">{errors.lastName?.type === 'pattern' && "Space not allowed"}</small>
                                    </div>
                                </div>


                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Phone
                                            <span size="5" className="error-star">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="phone"
                                            className="form-control"
                                            placeholder={PHONE_PLACEHOLDER}
                                            defaultValue={props.formData ? handlePhoneNumberForDirectData(props.formData.phone) : null}
                                            {...register("contact", {
                                                required: true,
                                                pattern: NUMBER_FORMAT_REGEX, onChange: handlePhoneNumber
                                            })}
                                        />
                                        <small className="text-danger">{errors.contact?.type === 'required' && "Phone is required"}</small>
                                        <small className="text-danger">{errors.contact?.type === 'pattern' && "Invalid phone number"}</small>
                                    </div>


                                    <div className="form-group col-md-6">
                                        <label>Email
                                            <span size="5" className="error-star">
                                                *
                                            </span>
                                        </label>
                                        <div className="input-group mb-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter email Username"
                                                defaultValue={props.formData && props.formData.email ? props.formData.email.split("@")[0] : null}
                                                {...register("emailUsername", { required: true, pattern: EMAILUSERNAMEREGEX })}
                                            />

                                            <div className="input-group-prepend">
                                                <div className="input-group-text user-form-group">@</div>
                                                <div className="input-group-text user-form-group">
                                                    <select className="form-control form-control-sm"
                                                        {...register("domain", {
                                                            required: true,
                                                            value: props.formData && props.formData.email ? props.userAuthReducer && props.userAuthReducer.authUser && props.userAuthReducer.authUser.userRoleId != USER_ROLES.ADMIN && props.userAuthReducer.authUser.userRoleId != USER_ROLES.BROKER ?
                                                                Array.isArray(props.userAuthReducer.domainList) &&
                                                                    props.userAuthReducer.domainList.length > 0 &&
                                                                    props.userAuthReducer.domainList.find(domain => domain && !domain.isDeleted && props.formData.email.split("@")[1] == domain.domainURL) ? setValue('domain', props.userAuthReducer.domainList.length > 0 &&
                                                                        props.userAuthReducer.domainList.find(domain => domain && !domain.isDeleted && props.formData.email.split("@")[1] == domain.domainURL).domainURL.trim()) : null
                                                                :
                                                                props.formData.email.split("@")[1] == "oncidium.ca" ?
                                                                    props.formData.email.split("@")[1] : null : null
                                                        })}
                                                    >
                                                        {!isAdminRole && <option value="">-:Select Domain:-</option>}
                                                        {(isAdminRole || isBrokerRole) && <option value="oncidium.ca">oncidium.ca</option>}
                                                        {!isAdminRole && props.userAuthReducer &&
                                                            Array.isArray(props.userAuthReducer.domainList) &&
                                                            props.userAuthReducer.domainList.length > 0 &&
                                                            props.userAuthReducer.domainList.map((domain, index) => {
                                                                return (
                                                                    !domain.isDeleted && <option
                                                                        selected={props.formData && props.formData.email && (props.formData.email.split("@")[1] == domain.domainURL) && "selected"}
                                                                        value={domain.domainURL}>
                                                                        {domain.domainURL}
                                                                    </option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                            </div>
                                        </div>
                                        <small className="text-danger">{errors.emailUsername?.type === 'required' && "Email is required"}</small>
                                        <small className="text-danger">{errors.emailUsername?.type === 'pattern' && "Invalid email username"}</small>
                                        <small className="text-danger">{errors.emailUsername?.type != 'required' && errors.emailUsername?.type != 'pattern' && errors.domain?.type === 'required' && "Domain is required"}</small>
                                    </div>
                                </div>

                                {props.isPasswordFiedShown &&
                                    <div className="form-row">

                                        <div className="form-group col-md-6">
                                            <label>Password
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                placeholder="Password"
                                                name="password"
                                                {...register("password", {
                                                    required: "You must specify a password", pattern: PASSWORDREGEX
                                                })}
                                            />
                                            <small className="text-danger">{errors.password && <p>{errors.password.message}</p>}</small>
                                            <small className="text-danger">{errors.password?.type === 'pattern' && PASSWORD_ERROR}</small>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>
                                                Confirm Password/Confirmer le mot de passe
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                placeholder="Confirm Password/Confirmer le mot de passe"
                                                name="confirmPassword"
                                                {...register("confirmPassword", {
                                                    validate: value =>
                                                        value === password.current || "The passwords do not match"
                                                })}
                                            />
                                            <small className="text-danger">{errors.confirmPassword && <p>{errors.confirmPassword.message}</p>}</small>
                                        </div>
                                    </div>
                                }
                                {!isBrokerRole && !isAdminRole && selectedRole != USER_ROLES.ADMIN && selectedRole != 0 && <div className="form-row">
                                    {!isAdminRole && <div className="form-group col">
                                        <div className="example">
                                            <label>Region
                                                {!isFullHR && <span size="5" className="error-star">
                                                    *
                                                </span>}
                                            </label>
                                            <select className="form-control form-control-lg"
                                                {...register("regionId", {
                                                    required: !isFullHR ? true : false, value: props.formData.regionId, onChange: handleRegionChange
                                                })}
                                            >
                                                <option value="">-:Select Option:-</option>
                                                {props.userAuthReducer && props.userAuthReducer.regionList.map((region) => {
                                                    return (
                                                        <option
                                                            selected={props.formData && (props.formData.regionId == region.coRegionID_PK) && "selected"}
                                                            value={region.coRegionID_PK}>
                                                            {region.regionName}
                                                        </option>
                                                    )
                                                })
                                                }
                                            </select>
                                            <small className="text-danger">{errors.regionId?.type === 'required' && "region is required"}</small>

                                        </div>
                                    </div>}

                                    {!isAdminRole && isRegion && <div className="form-group col-md-6">
                                        <div className="example">
                                            <label>Department
                                                {!isFullHR && <span size="5" className="error-star">
                                                    *
                                                </span>}
                                            </label>
                                            <select className="form-control form-control-lg"
                                                {...register("departmentId", {
                                                    required: !isFullHR ? true : false, value: props.formData.departmetId
                                                })}
                                            >
                                                <option value="">-:Select Option:-</option>
                                                {props.userAuthReducer && props.userAuthReducer.departmentList.map((department) => {
                                                    return (
                                                        <option
                                                            selected={props.formData && (props.formData.departmetId == department.coLocationID_PK) && "selected"}
                                                            value={department.coLocationID_PK}>
                                                            {department.externalID}
                                                        </option>
                                                    )
                                                })
                                                }
                                            </select>
                                            <small className="text-danger">{errors.departmentId?.type === 'required' && "department is required"}</small>

                                        </div>
                                    </div>}

                                </div>}

                                {/* {selectedRole == USER_ROLES.FULL_HR ?
                                    <div className="form-row">
                                        <div className="form-group col">
                                            <div className="example">
                                                <label>Select Level
                                                    <span size="5" className="error-star">
                                                        *
                                                    </span>
                                                </label>
                                                <select className="form-control form-control-lg"
                                                    {...register("level", {
                                                        required: true, value: props.formData.level, onChange: handleLevelChange
                                                    })}
                                                >
                                                    <option value="">-:Select Option:-</option>
                                                    {props.levels && props.levels.map((level) => {
                                                        return (
                                                            <option
                                                                selected={props.formData && (props.formData.level == level.ID) && "selected"}
                                                                value={level.ID}>
                                                                {level.Value}
                                                            </option>
                                                        )
                                                    })
                                                    }
                                                </select>
                                                <small className="text-danger">{errors.level?.type === 'required' && "Level is required"}</small>

                                            </div>
                                        </div>

                                        {isLevel && <div className="form-group col-md-6">
                                        <div className="example">
                                            <label>Level Item
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <select className="form-control form-control-lg"
                                                {...register("levelItem", {
                                                    required: true, value: props.formData.departmetId
                                                })}
                                            >
                                                <option value="">-:Select Option:-</option>
                                                {props.userAuthReducer && props.userAuthReducer.levelItem.map((item) => {
                                                    return (
                                                        <option
                                                            selected={props.formData && (props.formData.levelItem == item.levelId) && "selected"}
                                                            value={item.levelId}>
                                                            {item.level}
                                                        </option>
                                                    )
                                                })
                                                }
                                            </select>
                                            <small className="text-danger">{errors.departmentId?.type === 'required' && "department is required"}</small>

                                        </div>
                                    </div>}
                                    </div>
                                    : null} */}

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Password Expiry Period (In Days)
                                            <span size="5" className="error-star">
                                                *
                                            </span>
                                        </label>
                                        <input
                                            type="number"
                                            min={0}
                                            className="form-control"
                                            placeholder="Password Expiry"
                                            name="passwordExpiry"
                                            defaultValue={props.formData ? props.formData.passwordPeriod : null}
                                            {...register("passwordExpiry", {
                                                required: "You must specify a Password Expiry Period",
                                                pattern: NUMBERREGEX
                                            })}
                                        />
                                        <small className="text-danger">{errors.passwordExpiry && <p>{errors.passwordExpiry.message}</p>}</small>
                                        <small className="text-danger">{errors.password?.type === 'pattern' && "Text not allowed"}</small>
                                    </div>
                                    {!isBrokerRole && selectedRole != USER_ROLES.BROKER && !isAdminRole && selectedRole != USER_ROLES.ADMIN && selectedRole != 0 &&
                                        <div className="form-group col-md-6">
                                            <label>Ein
                                                <span size="5" className="error-star">
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Ein"
                                                defaultValue={props.formData ? trim(props.formData.ein) : null}
                                                {...register("ein", { required: true, pattern: SPACE_NOT_ALLOWD })}
                                            />
                                            <small className="text-danger">{errors.ein?.type === 'required' && "Ein is required"}</small>
                                            <small className="text-danger">{errors.ein?.type === 'pattern' && "Space not allowed"}</small>
                                        </div>}
                                </div>
                                <div className="form-row">
                                    <button type="submit" className="btn btn-primary float-right">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};
export default AddUserForm;
